var React = require("react");
var ApplicationContext = require("../../config/ApplicationContext.js");
var EditorLaunchUtil = require("../../util/EditorLaunchUtil.js");

var Feature = require("../empty/Feature.jsx");

class EmptyPackageCard extends React.Component {
    componentWillMount(){
		this.linkPackage = ApplicationContext.getPackageEditor();
    }

    render() {
        return (
        	<div>
                <div className="empty">
                <p>Packages you create or import from Fusion Electronics libraries will appear here. <a href={EditorLaunchUtil.editorUrl(this.linkPackage, { hub: this.props.idHub })}>Create a package</a> to get started!</p>
                </div>

                <Feature idHub={this.props.idHub}/>
            </div>
        );
    }
}


module.exports = EmptyPackageCard;
